import React from "react";
import {GridCell} from "../../Components/Grid";
import {
    Button, checkAndSetError,
    clearInputFormErrorFields,
    InputForm,
    inputFormIsValid,
    PasswordField,
    useInputForm
} from "../../Components/Inputs";
import {PageTitle} from "../../Components/Landmarks";
import {LayoutMedium} from "../../Components/Layout";
import {Link} from "../../Components/Link";
import {locations} from "../../Utilities/Location";

interface PasswordUpdateViewProps {
    isLoading: boolean;
    handleUpdatePassword: (password: string) => void;
    setWarnings: (val: string[]) => void;
    isLinkExpired: boolean;
}

export const PasswordUpdateView: React.FC<PasswordUpdateViewProps> = ({isLoading, handleUpdatePassword, setWarnings, isLinkExpired}) => {

    const form = useInputForm({password: "", confirmPassword: ""});

    const isFormValid = () => {
        clearInputFormErrorFields(form);

        checkAndSetError([
            form.password,
            form.confirmPassword,
        ]);

        if (form.confirmPassword.value !== form.password.value) {
            form.password.setError("Password fields must match.");
        }

        let isValid = inputFormIsValid(form);

        if (!isValid)
            setWarnings(["Missing required items.  Please review your responses and try submitting again."]);

        return isValid;
    };

    const handleClickSubmit = async () => {
        if (isFormValid()) {
            handleUpdatePassword(form.password.value);
        }
    };

    return <>
        <PageTitle h1={`Update Password`}/>

        {
            isLinkExpired &&
            <p className={`text-center`}>Your password reset link is expired. <br/>
                Please request a <Link {...locations.FORGOT_PASSWORD.link} label={`new link`}/>.
            </p>
        }
        {
            !isLinkExpired &&
            <LayoutMedium>
                <InputForm name={"updatePw"}>
                    <PasswordField {...form.password} />

                    <PasswordField {...form.confirmPassword} />

                    <GridCell>
                        <Button
                            isPrimary
                            name="btnSubmit"
                            label="Submit"
                            onClick={handleClickSubmit}
                            disabled={isLoading}
                        />
                    </GridCell>
                </InputForm>
            </LayoutMedium>
        }

    </>;
};
